import { MutationTree } from 'vuex';
import { UIState } from './types';

export const mutations: MutationTree<UIState> = {
    taskbarVisibility(state, payload: boolean) {
        state.taskbarVisible = payload;
    },
    sidebarVisibility(state, payload: boolean) {
        state.sidebarVisible = payload;
    },
    sidebarExpanded(state, payload: boolean) {
        state.sidebarExpanded = payload;
    },
    appVisibility(state, payload: boolean) {
        state.appVisible = payload;
    }
};
